import { render, staticRenderFns } from "./SphereVideoTrack.vue?vue&type=template&id=561ef496&scoped=true&"
import script from "./SphereVideoTrack.vue?vue&type=script&lang=js&"
export * from "./SphereVideoTrack.vue?vue&type=script&lang=js&"
import style0 from "./SphereVideoTrack.vue?vue&type=style&index=0&id=561ef496&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ef496",
  null
  
)

export default component.exports